import { Component } from '@angular/core';

@Component({
  selector: 'no-content',
  template: `
  <div class="page-not-found">
    <div class="content content-not-found">
        <div class="text-not-found">
            <h1>
                Desculpe, não conseguimos<br> encontrar essa página.
            </h1>
            <p>
                Estamos de casa nova e algumas coisas mudaram de lugar.<br>
                Tente digitar novamente o endereço ou volte para nossa página inicial.
            </p>
            <button class="btn" [routerLink]="['/home']">
                <p>ACESSE A PÁGINA INICIAL &gt;</p>
            </button>
        </div>
        <div class="image-not-found">
            <img src="assets/shared/img/robot-not-found.png">
        </div>
    </div>
</div>
  `
})

export class NoContentComponent {}
